import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import { useCreateSchoolLeavingCertificateMutation } from "../Redux/actions/certificate.action"
import { updateFields, resetForm } from "../Redux/actions/formValue.action"
import { useSelector, useDispatch } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"
import _ from "lodash"

const SchoolLeavingForm = () => {
    const dispatch = useDispatch()
    const [generateSchoolLeaveCer, generateSchoolLeaveCerState] = useCreateSchoolLeavingCertificateMutation()

    const formValue = useSelector(state => state.form)
    const issue_date = _.get(formValue, "state.issue_date", "")
    const student_name = _.get(formValue, "state.student_name", "")
    const parent_name = _.get(formValue, "state.parent_name", "")
    const admission_number = _.get(formValue, "state.admission_number", "")
    const from_year = _.get(formValue, "state.from_year", "")
    const to_year = _.get(formValue, "state.to_year", "")
    const last_class = _.get(formValue, "state.last_class", "")
    const date_of_leaving = _.get(formValue, "state.date_of_leaving", "")
    const reason_for_leaving = _.get(formValue, "state.reason_for_leaving", "")
    const institution_name = _.get(formValue, "state.institution_name", "")
    const institution_address = _.get(formValue, "state.institution_address", "")
    const authority = _.get(formValue, "state.authority", "")


    React.useEffect(() => {
        if (generateSchoolLeaveCerState.isSuccess) {
            const blob = generateSchoolLeaveCerState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "bonafide_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generateSchoolLeaveCerState.reset()
            dispatch(resetForm())
        } else if (generateSchoolLeaveCerState.isError) {
            toaster.push(<Message type="error" >Error while create the School Leaving certificate,Please try again later!</Message>, { placement: "topCenter" })
            generateSchoolLeaveCerState.reset()
        }
    }, [generateSchoolLeaveCerState.status])
    const handleSubmit = () => {
        if (
            !issue_date || !student_name || !parent_name || !admission_number || !from_year || !to_year || !last_class ||
            !date_of_leaving || !reason_for_leaving || !institution_name || !institution_address || !authority
        ) {
            toaster.push(<Message type="info">Please fill all fields value!</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            issue_date,
            student_name,
            parent_name,
            admission_number,
            from_year,
            to_year,
            last_class,
            date_of_leaving,
            reason_for_leaving,
            institution_name,
            institution_address,
            authority
        }
        generateSchoolLeaveCer(data)
    }

    return (
        <Box sx={{ maxWidth: 720, mx: "auto", mt: 5 }}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        School Leaving Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Enter student and school details carefully
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Issue Date"
                            name="issue_date"
                            placeholder="DD-MM-YYYY"
                            fullWidth
                            value={issue_date}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ issue_date: val }))
                            }}
                            type="date"
                            focused
                        />

                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            value={student_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ student_name: val }))
                            }}
                        />

                        <TextField
                            label="Parent / Guardian Name"
                            name="parent_name"
                            fullWidth
                            value={parent_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ parent_name: val }))
                            }}
                        />

                        <TextField
                            label="Admission Number"
                            name="admission_number"
                            fullWidth
                            value={admission_number}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ admission_number: val }))
                            }}
                        />

                        <TextField
                            label="From Academic Year"
                            name="from_year"
                            placeholder="2018"
                            fullWidth
                            value={from_year}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({
                                    from_year: val
                                }))
                            }}
                        />

                        <TextField
                            label="To Academic Year"
                            name="to_year"
                            placeholder="2024"
                            fullWidth
                            value={to_year}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ to_year: val }))
                            }}
                        />

                        <TextField
                            label="Last Class Studied"
                            name="last_class"
                            placeholder="X"
                            fullWidth
                            value={last_class}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ last_class: val }))
                            }}
                        />

                        <TextField
                            label="Date of Leaving"
                            name="date_of_leaving"
                            placeholder="DD-MM-YYYY"
                            fullWidth
                            value={date_of_leaving}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ date_of_leaving: val }))
                            }}
                            type="date"
                            focused
                        />

                        <TextField
                            label="Reason for Leaving"
                            name="reason_for_leaving"
                            multiline
                            rows={2}
                            fullWidth
                            value={reason_for_leaving}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ reason_for_leaving: val }))
                            }}
                        />

                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            fullWidth
                            value={institution_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />

                        <TextField
                            label="Institution Address"
                            name="institution_address"
                            multiline
                            rows={2}
                            fullWidth
                            value={institution_address}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ institution_address: val }))
                            }}
                        />

                        <TextField
                            label="Issuing Authority"
                            name="authority"
                            placeholder="Principal"
                            fullWidth
                            value={authority}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ authority: val }))
                            }}
                        />
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generateSchoolLeaveCerState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    );
};

export default SchoolLeavingForm
